export const utils = {
  numberFromPrice: (price) => {
    // if price is not a string, return 0
    if (!price || typeof price !== "string") return 0;
    // Remove trailing zeroes and special characters
    price = price?.replace(/[^0-9.]/g, "");
    // Convert to number
    price = parseFloat(price);
    // Return number
    return price;
  },
  formatPrice: (price) => {
    if (!price) return 0;
    // Convert to number
    price = utils.numberFromPrice(price);
    // Format price
    price = price.toFixed(2);
    // Return formatted price
    return price;
  },
  // Shopify prices are in cents, convert to dollars
  formatShopifyPrice: (price) => {
    if (!price) return 0;
    // Convert to dollars
    price = price / 100;
    // Format price
    price = price.toFixed(2);
    // Return formatted price
    if (typeof price === "string") {
      price = utils.numberFromPrice(price);
    }
    return price;
  },

  // SmartCart Helpers
  addToCart(variant = {}, quantity = 1, options = {}) {
    const cart = window.Rebuy?.Cart;
    // Guards
    if (!cart) {
      console.error("Rebuy not initialized yet");
      return;
    }

    if (!variant.id) {
      console.error("No variant object provided");
      return;
    }

    // Add quantity to Variant
    variant["quantity"] = quantity;

    // If the variant has options, add each key the variant object
    if (options) {
      Object.keys(options).forEach((key) => {
        variant[key] = options[key];
      });
    }

    // Add to Rebuy Cart object
    cart.addItem(variant);
  },
};
